import { Controller } from '@hotwired/stimulus'
import { changeProductSelection } from '../selection/product-selection-api'
import { handleSpecialOrderColorClick } from '../selection/special-order-handler'
import { changePutup } from '../putup/putup-handler'

export default class extends Controller {
  static targets = ['state']

  connect() {
    this.attachProductPickerHandlers()
    this.attachSpecialOrderHandlers()
    this.attachPutupHandlers()
  }

  attachProductPickerHandlers() {
    // Color, style, and size pickers now use their own Stimulus controllers
    // Only attach handlers to remaining product pickers if any
    const pickers = this.element.querySelectorAll('.product-picker:not([data-controller~="color-picker"]):not([data-controller~="style-picker"]):not([data-controller~="size-picker"])')
    pickers.forEach(picker => {
      picker.addEventListener('click', (e) => this.handlePickerClick(e))
    })
  }

  attachSpecialOrderHandlers() {
    const buttons = this.element.querySelectorAll('.special-order-color-button')
    buttons.forEach(button => {
      button.addEventListener('click', (e) => handleSpecialOrderColorClick(e.currentTarget))
    })
  }

  attachPutupHandlers() {
    const putupButtons = this.element.querySelectorAll('.uom-picker-button')
    putupButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const box = e.currentTarget.closest('[data-box]')?.dataset.box || '1'
        changePutup(box, e.currentTarget)
      })
    })

    // Quantity inputs now use data-action attributes for proper Stimulus handling
    // This ensures live updates via 'input' event and final updates via 'change' event
    
    // Value-added checkboxes now handled by value-added-controller
  }

  handlePickerClick(event) {
    const clickedElement = event.currentTarget
    const stateElement = this.hasStateTarget 
      ? this.stateTarget 
      : document.getElementById('product-selection-state')
    
    if (!stateElement) {
      console.error('Product selection state element not found')
      return
    }

    changeProductSelection(clickedElement, stateElement)
  }

  /**
   * Handle quantity input event (fires on every keystroke for live updates)
   * @param {Event} event - The input event
   */
  handleQuantityInput(event) {
    const box = event.currentTarget.closest('[data-box]')?.dataset.box || '1'
    changePutup(box, event.currentTarget)
  }

  /**
   * Handle quantity change event (fires on blur for final value)
   * @param {Event} event - The change event
   */
  handleQuantityChange(event) {
    const box = event.currentTarget.closest('[data-box]')?.dataset.box || '1'
    changePutup(box, event.currentTarget)
  }

  reattachHandlers() {
    this.attachProductPickerHandlers()
    this.attachSpecialOrderHandlers()
    this.attachPutupHandlers()
  }
}
